/* @flow */
/* eslint-env es6,browser */
import { IDP_COOKIE_EXPIRY_DAYS } from './idpconstants';

/**
 * @global
 * @typedef _perIDPConfig
 * @property {string} url URL for IDP
 * @property {string} pid unique ID
 * @property {number} expires cookie/cache expiry
 */

/**
 * @module _idpbase
 * @description IdentityProvider base module
 */

/**
 * @class _idpbase
 * @description IdentityProvider base class
 */

export default class _idpbase {
  _doc: Document;

  _win: window;

  _name: string;

  _cachedID: string;

  _url: string;

  _pid: string;

  _nExpireDays: number;

  /**
   * @class
   * @param {string} name - IDProvider name
   */
  constructor(name: string = '') {
    this._doc = document;
    this._win = window;
    this._name = name;
    this._cachedID = '';
    // config for partner
    this._url = '';
    this._pid = '';
    this._nExpireDays = IDP_COOKIE_EXPIRY_DAYS;
  }

  /**
   * Initialize the object - called from adserver initialize
   *
   * @param {window} w - window object
   * @param {Document} d - document object
   * @param {module:globalParams.globalParams} [g] - global param object
   * @returns {undefined}
   */
  // eslint-disable-next-line no-unused-vars
  init(w: window, d: Document, g: globalParam) {
    this._doc = d;
    this._win = w;
  }

  /**
   * Update config - called from adserver updateConfig
   *
   * @param {_perIDPConfig} [o] - adserver config from adconfig
   * @returns {undefined}
   */
  // eslint-disable-next-line no-unused-vars
  updateConfig({
    url = '',
    pid = '',
    expires = IDP_COOKIE_EXPIRY_DAYS
  }: perIDPConfig) {
    this._url = url;
    this._pid = pid;
    this._nExpireDays = expires;
  }

  /**
   *
   *
   * @returns {*}  {string}
   * @memberof _idpbase
   */
  getName(): string {
    return this._name;
  }

  /**
   * Update cached ID if required
   *
   * @memberof _idpbase
   * @returns {undefined}
   */
  _refreshID(): ?string {
    return this._cachedID;
  }

  /**
   * Get id from this provider.
   * If it's async/server request, will return cached value
   *
   * @returns {*}  {string}
   * @memberof _idpbase
   * @param {string} idpKey - Key for ID module in Multi ID providers
   */
  // eslint-disable-next-line no-unused-vars
  getID(idpKey: string = ''): string {
    this._refreshID();
    return this._cachedID;
  }
}
